import { c as _c } from "react/compiler-runtime";
import { cn } from '@module/lib/utils';
import type * as React from 'react';
type Props = {
  size?: number;
  className?: string;
};
export const PendingSpinner: React.FC<Props> = t0 => {
  const $ = _c(7);
  const {
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? 24 : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("animate-spin text-current", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />;
    t4 = <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z" />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== size || $[5] !== t2) {
    t5 = <svg width={size} height={size} viewBox="0 0 24 24" className={t2} aria-hidden={true} focusable="false">{t3}{t4}</svg>;
    $[4] = size;
    $[5] = t2;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
export default PendingSpinner;